// extracted by mini-css-extract-plugin
module.exports = {"collapse":"y+sSn","opened":"N21uX","icon":"WaFJb","content":"LGF1a","label":"I6vVJ"};